'use strict';

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.chooseMethod = chooseMethod;

var _localStorage = require('./methods/localStorage');

var _localStorage2 = _interopRequireDefault(_localStorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Order is important
var METHODS = [_localStorage2.default];

function chooseMethod() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (options.type) {
    // Chosen type
    var method = METHODS.find(function (m) {
      return m.type === options.type;
    });
    if (!method) throw new Error('\u274C Method ' + options.type + ' is not supported.');else return method;
  }

  var useMethod = METHODS.find(function (method) {
    return method.canBeUsed();
  });

  /* istanbul ignore next */
  if (!useMethod) {
    throw new Error('\u274C No method found ' + (0, _stringify2.default)(METHODS.map(function (m) {
      return m.type;
    })));
  }
  return useMethod;
}